// مفاتيح ميزات الشركة (مطابقة لـ backend/core/features.py). الأساس دائماً: الحضور والإجازات.
export const FEATURE_KEYS = [
  "accounting",
  "payroll_cycle",
  "duties",
  "live_map",
  "cash_transfers",
  "fx_rates",
  "api_webhooks",
  "service_requests",
  "company_backup",
  "company_broadcast",
];
